module.exports = __webpack_public_path__ + "media/images/emblems/Gossau-blazon-2f93b95aa691f3cd7b8ff5bcaf866101.svg";